import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { useSocialSignIn, signInWithRedirect } from "@theprelude/core";
import { Button, GoogleIcon, LockIcon, notifyError } from "@theprelude/ds";
import { z } from "zod";
import AuthPage from "@/components/auth-page";

const cliAuthSchema = z.object({
  handle: z.string().optional().catch(undefined),
  provider: z.enum(["google", "custom"]).optional().catch(undefined),
  slug: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/cli-auth")({
  beforeLoad: async ({ search }) => {
    const params = {
      options: {
        loginHint: search.handle,
      },
    };

    if (search.provider === "google") {
      return await signInWithRedirect({
        provider: "Google",
        ...params,
      });
    }

    if (search.provider === "custom") {
      throw redirect({
        to: "/sso",
        search: {
          handle: search.handle,
          slug: search.slug,
        },
      });
    }
    throw new Error("Unexpected OIDC issuer provided.");
  },
  validateSearch: cliAuthSchema,
  component: CLIAuthPage,
});

function CLIAuthPage() {
  const search = Route.useSearch();
  const socialSignIn = useSocialSignIn();

  return (
    <AuthPage title="Sign in to Prelude">
      <main>
        <div className="flex flex-col gap-4 pt-4">
          <Button
            intent="secondary"
            className="flex w-full justify-center bg-primary-foreground text-white dark:text-black"
            icon={<GoogleIcon />}
            onClick={() => {
              socialSignIn.mutate(
                { provider: "Google", handle: search.handle },
                {
                  onError: (error) => {
                    notifyError({
                      message: "Failed to sign in. Please try again.",
                      error,
                    });
                  },
                },
              );
            }}
          >
            Sign in with Google
          </Button>

          <Link to="/sso">
            <Button
              className="flex w-full justify-center bg-primary-foreground text-white dark:text-black"
              icon={<LockIcon className={"text-white dark:text-black"} />}
            >
              Continue with Single Sign-On
            </Button>
          </Link>
        </div>
      </main>
    </AuthPage>
  );
}
